import type { FC } from "react";

import type { DashboardOverview } from "../../../types";

import { NodeTelemetryTable } from "../NodeTelemetryTable";
import { RecentTasksPanel } from "../RecentTasksPanel";

interface OverviewViewProps {
  data: DashboardOverview;
  onRefresh: () => void;
  onNavigateToIndexing?: (repoSlug: string) => void;
}

export const OverviewView: FC<OverviewViewProps> = ({
  data,
  onRefresh,
  onNavigateToIndexing,
}) => {
  const {
    nodes,
    tasks: { summary, recent },
  } = data;

  return (
    <>
      <NodeTelemetryTable nodes={nodes} />

      <RecentTasksPanel
        tasks={recent}
        taskTotal={summary.total}
        onRefresh={onRefresh}
        onNavigateToIndexing={onNavigateToIndexing}
      />
    </>
  );
};
